export const resume = {
	title: "Resumo",
	description:
		"Confira se todas as informações estão corretas e depois publique a promoção. Ela vai ser ativada automaticamente e já vai estar pronta para uso.",
	sections: {
		allProducts: "Todos os produtos",
		andMore: "e mais {{count}} produtos",
		promotionInfo: {
			title: "Dados da promoção",
			channel: "Canal",
			audience: "Quem poderá receber a promoção",
			audienceValues: {
				everybody: "Todos os clientes",
				identifiedCpf: "Clientes identificados",
			},
			cpfPermissionWarning:
				"Para identificar os clientes no totem ficha é necessário que a permissão 'captar CPF no totem ficha' esteja ativada.",
			name: "Nome",
			description: "Descrição",
			maxUses: {
				label: "Quantidades de usos por ganho",
				uses: "{{uses}} usos",
				withoutLimits: "Sem limites",
			},
			places: "Locais",
		},
		goals: {
			title: "Metas",
			frequency: "Recorrência de ganhos",
		},
		awards: {
			title: "Prêmios",
			discount: "Desconto(%) sobre o valor do produto",
			products: "Produtos do desconto",
		},
		usageConditions: "Condições do uso",
	},
};
